import React from 'react';
import { useLanguage } from './LanguageContext';

const translations = {
  en: {
    badge: 'People Are Talking',
    title: 'Don\'t take our word for it.',
    subtitle: 'Here\'s what happens when real people open their fridge and let Chaiffy do its thing.',
    testimonials: [
      {
        quote: 'I had leftover chicken, some peppers, and yogurt. Chaiffy gave me a chicken shawarma bowl recipe in seconds. My family thought I ordered from a restaurant.',
        name: 'Noura',
        location: 'Riyadh',
        emoji: '👩‍🍳',
      },
      {
        quote: 'I used to throw away vegetables every week. Now I just scan what\'s left on Thursday and cook something new. Haven\'t wasted food in two months.',
        name: 'Ahmed',
        location: 'Jeddah',
        emoji: '👨‍💻',
      },
      {
        quote: 'The best part? It actually knows Saudi food. I asked it to use dates and cardamom and it gave me a dessert recipe my grandmother would approve of.',
        name: 'Sara',
        location: 'Dammam',
        emoji: '👩‍🎓',
      },
    ],
    stat1: '10,000+',
    stat1Label: 'meals created',
    stat2: '3 sec',
    stat2Label: 'average recipe time',
    stat3: '97%',
    stat3Label: 'satisfaction rate',
  },
  ar: {
    badge: 'الناس تتكلم',
    title: 'لا تأخذ كلامنا فقط.',
    subtitle: 'هذا اللي يصير لما ناس حقيقيين يفتحون ثلاجتهم ويخلون Chaiffy يشتغل.',
    testimonials: [
      {
        quote: 'كان عندي دجاج متبقي، شوية فلفل، وزبادي. Chaiffy أعطاني وصفة شاورما بول في ثوانٍ. عائلتي افتكروا إني طالب من مطعم.',
        name: 'نورة',
        location: 'الرياض',
        emoji: '👩‍🍳',
      },
      {
        quote: 'كنت أرمي خضار كل أسبوع. الحين أمسح اللي باقي يوم الخميس وأطبخ شي جديد. ما هدرت أكل من شهرين.',
        name: 'أحمد',
        location: 'جدة',
        emoji: '👨‍💻',
      },
      {
        quote: 'أحلى شي؟ إنه فعلاً يعرف الأكل السعودي. طلبت منه يستخدم تمر وهيل وأعطاني وصفة حلى جدتي بتوافق عليها.',
        name: 'سارة',
        location: 'الدمام',
        emoji: '👩‍🎓',
      },
    ],
    stat1: '+10,000',
    stat1Label: 'وجبة تم إنشاؤها',
    stat2: '3 ثوانٍ',
    stat2Label: 'متوسط وقت الوصفة',
    stat3: '97%',
    stat3Label: 'نسبة الرضا',
  }
};

const Testimonials = () => {
  const { language, isRTL } = useLanguage();
  const t = translations[language];

  return (
    <section className="section-padding bg-white" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-100 text-amber-700 rounded-full text-xs font-bold uppercase tracking-widest mb-5">
            {t.badge}
          </span>
          <h2 className="heading-lg text-dark mb-4">
            {t.title}
          </h2>
          <p className="body-lg max-w-lg mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {t.testimonials.map((item, index) => (
            <div 
              key={index} 
              className="bg-gray-50 rounded-2xl p-6 md:p-8 relative card-hover border border-gray-100"
            >
              <div className="text-4xl text-gray-200 font-serif absolute top-4 right-5 select-none">"</div>
              <p className="text-gray-600 leading-relaxed mb-6 text-sm md:text-base relative z-10" style={{ fontFamily: 'Lato, sans-serif' }}>
                {item.quote}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-green flex items-center justify-center text-lg">
                  {item.emoji}
                </div>
                <div>
                  <div className="font-bold text-dark text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>{item.name}</div>
                  <div className="text-xs text-gray-400">{item.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-emerald-50 via-green-50 to-teal-50 rounded-3xl p-8 md:p-12">
          <div className="grid grid-cols-3 gap-4 text-center">
            {[
              { value: t.stat1, label: t.stat1Label },
              { value: t.stat2, label: t.stat2Label },
              { value: t.stat3, label: t.stat3Label },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-2xl md:text-4xl font-extrabold text-primary mb-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-gray-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
